module.exports = __webpack_public_path__ + "static/innovation-63c0c98c36cc5bab9420181164b4141c.png";